
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.516 20.5h22.968m-1.968 0v-14a4 4 0 00-4-4h-11a4 4 0 00-4 4v14m9-20v5m-2.985 0h5.985","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.516 12.5v-1a2.006 2.006 0 012-2h1a2.006 2.006 0 011.413.588c.374.374.585.882.587 1.412v1m2 0h-9a2 2 0 00-2 2v4a2 2 0 002 2h9a2 2 0 002-2v-4a2 2 0 00-2-2zm4.5 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-18 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    